// A preference the user changed while signed out, waiting to be written to
// their account at next sign-in.
//
// This exists to keep one specific bug out: promoting whatever happens to be
// in localStorage would mean the last device someone used silently overwrites
// their account setting. Only an explicit change made while signed out is
// promoted — a value that arrived in localStorage as a mirror of the server
// (the normal case after any login) is not a choice and must not be written
// back.
//
// Design D4's "server wins" rule is unchanged for everything else; this is the
// one narrow case where the local value is newer than the account's.
const KEY = 'ciPendingPreferences'

function read() {
  try {
    const raw = localStorage.getItem(KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null // unparseable or storage blocked — treat as nothing pending
  }
}

// Records an explicit signed-out change. Merges, so choosing a theme and then
// a language before signing in promotes both.
export function markPending(patch) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...(read() || {}), ...patch }))
  } catch {
    // Storage unavailable. The choice still applies for this session; it just
    // will not survive to be promoted.
  }
}

export function peekPending() {
  return read()
}

export function clearPending() {
  try {
    localStorage.removeItem(KEY)
  } catch { /* nothing to do */ }
}
